
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 20.424"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Rectangle 215","fill":"#fff","stroke":"#ddd"}},[_c('path',{attrs:{"stroke":"none","d":"M0 .424h20v20H0z"}}),_c('path',{attrs:{"fill":"none","d":"M.5.924h19v19H.5z"}})]),_c('path',{staticClass:"checkmark",attrs:{"d":"M10.95 14.584a.445.445 0 0 1-.319-.131l-4.5-4.5a.45.45 0 0 1 .635-.638l4.183 4.187L23.232 1.214a.452.452 0 0 1 .635 0 .445.445 0 0 1 0 .633l-12.6 12.606a.44.44 0 0 1-.318.131z","fill":"#35bdd1","stroke":"#35bdd1","stroke-width":"2"}})])
          )
        }
      }
    